<template>
  <b-card style="overflow: hidden;">
    <template #header>
      <h5 class="card-title">CTA</h5>
    </template>
    <div class="d-flex align-items-center">
      <template v-if="showContent">
        <b-form-checkbox @change="$emit('updateShowSection', $event, 'show-cta-type-1', apiGet)" id="preview" value="Y" unchecked-value="N" name="preview" v-model="showContent">Show Section?</b-form-checkbox>
      </template>
  
      <b-button variant="secondary" class="btn-rounded ml-auto" v-if="previewOpen" @click="closePreviewForm">
        Close <i class="fas fa-times ml-2"></i>
      </b-button>
      <b-button variant="outline-info" class="btn-rounded ml-auto" @click="showPreviewUpdate" v-else>
        Update Content <i class="fas fa-pencil-alt ml-2"></i>
      </b-button>
  
    </div>
    <hr />
  
    <validation-observer v-slot="{ handleSubmit }" ref="VFormDescription" tag="div" v-if="previewOpen">
      <b-form @submit.prevent="handleSubmit(doSubmitDesc)">
        <b-card class="border mb-0">
          <template #header>
            <h5 class="card-title">Content</h5>
          </template>
          <b-row class="mb-2">
            <b-col md=6>
              <div class="form-group">
                <label class="control-label">Content</label>
                <CKEditor :value.sync="row.asc_content" />
                <VValidate name="Content" v-model="row.asc_content" rules="min:3" />
              </div>
            </b-col>
            <b-col md=4>
              <div class="form-group">
                <label class="control-label">Button Label <span class="text-danger">*</span></label>
                <b-form-input v-model="row.asc_button_label" />
                <VValidate name="Button Label" v-model="row.asc_button_label" rules="required|min:3|max:160" />
              </div>
            </b-col>
          </b-row>
          <template #footer>
            <div class="text-right">
              <b-button variant="secondary" class="btn-rounded mr-3" @click="closePreviewForm">Cancel</b-button>
              <button type="submit" class="btn btn-info btn-rounded">Save Changes</button>
            </div>
          </template>
        </b-card>
      </b-form>
    </validation-observer>
  
    <template v-else>
      <div class="row justify-content-center">
        <div class="col-md-12">
          <section class="section bg-white">
            <div class="blop_left">
              <img src="/assets/images/blob-1.png">
            </div>
            <div class="blop_right">
              <img src="/assets/images/blob-2.png">
            </div>
            <div class="container">
              <div class="sect-heading mb-3">
                <h2 class="sect-heading__title text-center" v-html="row.asc_content"></h2>
              </div>
              <div class="row justify-content-center mt-2">
                <div class="col-md-auto text-center">
                  <div class="cta-col mt-3 mt-lg-0">
                    <a href="javascript:;" target="_blank" class="cta cta--secondary cta--arrow"> {{ row.asc_button_label }} <i class="ti-arrow-right"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </template>
  
  </b-card>
  </template>
  
  <script>
  import Gen from '@/libs/Gen.js'
  import CKEditor from "@/components/CKEditor.vue"
  // let _ = global._
  
  export default {
    components: { CKEditor },
    props: {
      modulePage: String
    },
    data() {
      return {
        previewOpen: false,
        achievementRow: {},
        row: {},
        achievement: [],
        validation: {},
        showContent: null
      }
    },
    computed: {
      parent() {
        return this.$parent.$parent.$parent
      }
    },
    mounted() {
      this.apiGet()
    },
    methods: {
      showPreviewUpdate() {
        this.previewOpen = true
      },
      closePreviewForm() {
        this.previewOpen = false
      },
      openModal(modal, data = null) {
        this.$bvModal.show(modal)
  
        this.$set(this, 'achievementRow', {
          typeLabel: 'Added'
        })
        if (data) this.$set(this, 'achievementRow', {
          ...this.achievementRow,
          ...data,
          typeLabel: 'Updated'
        })
      },
      doSubmitDesc() {
        this.$refs.VFormDescription.validate().then(success => {
          if (!success) return
  
          this.parent.swalLoading()
  
          Gen.apiRest('/do/' + this.modulePage, {
            data: {
              type: 'updateCTAType1',
              ...this.row
            }
          }).then(res => {
            if (res) {
              this.$swal({
                title: res.data.message,
                icon: 'success',
              }).then(() => {
                this.closePreviewForm()
                this.apiGet()
              })
            }
          }).catch(err => {
            this.$swal({
              title: err.response.data.message,
              icon: 'error'
            })
          })
        })
      },
      apiGet() {
        Gen.apiRest('/get/' + this.modulePage + '/cta_type_1', {}, 'GET').then(res => {
          this.row = res.data.row
          this.validation = res.data.validation
          this.showContent = res.data.showContent
        })
      }
    }
  }
  </script>
  <style scoped>
.cta--arrow {
  padding-right: 56px !important;
}

.cta--secondary {
  background-color: #F7C832 !important;
  border-color: #F7C832 !important;
}

.cta {
  font-size: 14px !important;
  border-radius: 5px !important;
  text-transform: uppercase !important;
  padding: 10px 58px 10px 28px !important;
  border: 1px solid transparent !important;
  color: #000 !important;
  background-color: transparent;
  display: inline-block !important;
  font-weight: 622300 !important;
  font-weight: 700 !important;
  position: relative !important;
  transition: 0.25s ease-in-out !important;
}

.cta--arrow i {
  position: absolute !important;
  top: -1px !important;
  right: -1px !important;
  bottom: -1px !important;
  width: 40px !important;
  border-radius: 5px !important;
  background-color: rgba(0, 0, 0, .125) !important;
  display: block !important;
  text-align: center !important;
  line-height: 46px !important;
  font-size: 18px !important;
  transition: 0.25s ease-in-out !important;
}
</style>